import React from "react";
import {Button, Card, WhiteSpace, Toast} from 'antd-mobile';
import { connect } from 'react-redux';

import applicationCenterService from '../../services/Employee/application-center-service';
import approvalCenter from "../../services/Employee/approval-center-service";

import MobileWrapper from '../../layouts/MobileWrapper';


class MobileApplyOvertimeDetail extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            data: props.fatherProps.location.state
        }

    }
    
    componentDidMount() {
      console.log(this.state)

        let id = this.state.data.id

        approvalCenter.fetchApprovalFlowLog({document_id:id}, res => {
            this.setState({
                stepsCurrent:res.data.currentStep,
                steps:res.data.steps
            })
            // console.log(this.state.steps)
        })
    }

    delApply = (approvalTypeStr, id) => {
        Toast.loading('正在撤销...', 99999, () => {});

        let posts = {
            id: id,
            approval_type_str: approvalTypeStr
        };
        applicationCenterService.UndoApproval(posts, res => {
            Toast.hide();

            if (res.data.Success) {
                Toast.success('撤销成功 !!!', 1);
            } else {
                Toast.fail('撤销失败 !!!', 1);
            }
        }, err => {
        });
    }


    urgeApproval = (approvalTypeStr, id) => {
        Toast.loading('正在催审...', 99999, () => {});

        let posts = {
            id: id,
            approval_type_str: approvalTypeStr
        };
        applicationCenterService.UrgeApproval(posts, res => {
            Toast.hide();

            if (res.data.Success) {

                Toast.success('催审成功 !!!', 1);
            } else {
                Toast.success('催审失败', 1);
            }
        }, err => {
        });
    }

    render() {
        const { currentUser } = this.props.user
        return <div>
            <WhiteSpace size="lg"/>
            <Card full>
                <Card.Header title={this.state.data.overtime_type_str} extra={<span>{this.state.data.approval_status_str}</span>}/>
                <Card.Body>
                    <div>加班日期: {this.state.data.overtime_date_str} </div>
                    <div>加班时间: {this.state.data.start_time} - {this.state.data.end_time}</div>
                    <div>加班时长: {this.state.data.overtime_hours} 小时</div>
                    <div>申请日期: {this.state.data.created_time_str}</div>
                    <div>加班事由: {this.state.data.remark}</div>
                </Card.Body>

                {
                    !!(this.state.data.approval_status === 1) &&

                    <Card.Footer content="" extra={<div>
                        {currentUser.PermissionDict.mobile_apply_overtime_list.revert_value &&
                        <Button  style={{width: '140px', float:"right", marginRight: "5px"}} 
                        size="small" type="warning" 
                        onClick={(e) => this.delApply(this.state.data.approval_type, this.state.data.id)}>撤销</Button>}
                    </div>}/>
                }


            </Card>

            <WhiteSpace/>
            <WhiteSpace/>
            {this.state.steps&&this.state.steps.map((step, index) => (
            <Card full key={index}>
                <Card.Header title={step.approval_user_name} 
                extra={<span>{step.status}</span>}
                />
                <Card.Body>
                    <div>{step.description}</div>
                </Card.Body>
                <Card.Footer content=""/>
            </Card>))}
            <WhiteSpace/>
            <WhiteSpace/>
            <WhiteSpace/>


            {
                !!(this.state.data.approval_status === 1) &&
                currentUser.PermissionDict.mobile_apply_overtime_list.urge_value &&
                <Button onClick={(e) => this.urgeApproval(this.state.data.approval_type, this.state.data.id)} type="primary">催审</Button>
            }


        </div>


    }
}

// export default MobileWrapper(MobileApplyOvertimeDetail);
const mapStateToProps = state => {
    return {
        user: state.user
    }
}
const mapDispatchToProps = {
}
export default MobileWrapper(connect(mapStateToProps, mapDispatchToProps)(MobileApplyOvertimeDetail));


// WEBPACK FOOTER //
// ./src/routes/Mobile/MobileApplyOvertimeDetail.js